enum ViolationType {
  MISSING_RECEIPT = "MISSING_RECEIPT",
  MISSING_ATTENDEES = "MISSING_ATTENDEES",
  MISSING_COST_ALLOCATION = "MISSING_COST_ALLOCATION",
  UNCATEGORIZED_EXPENSE_CATEGORY = "UNCATEGORIZED_EXPENSE_CATEGORY", // technically not a true violation in that it does NOT affect compliance
}

export default ViolationType;
